import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet, useWindowDimensions, ViewStyle} from 'react-native';

export default (props: ITheme) => {
  return StyleSheet.create({
    container: {
      backgroundColor: props.colors.lightGrey,
      borderRadius: 10,
      paddingLeft: 13,
      paddingRight: 13,
      paddingTop: 15,
      paddingBottom: 15,
      flex: 1,
      maxHeight: 100,
    },
  });
};
